import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
    selector: 'dk-dropdown',
    templateUrl: './dk-dropdown.component.html',
    styleUrl: './dk-dropdown.component.scss',
    standalone: false
})
export class DkDropdownComponent {
  /* -------------------------------------------------------------------------- */
  /*                                    label                                 */
  /* ------------------------------------------------------------------------ */
  @Input() label: string;

  // /* -------------------------------------------------------------------------- */
  // /*                               bootstrap grid                               */
  // /* -------------------------------------------------------------------------- */

  @Input() col = '12'; // mobile
  @Input() sm = '12'; // small
  @Input() md = '12'; // medium
  @Input() lg = '12'; // medium
  @Input() xl = '12'; // extra large

  @Input() has_my3 = false;
  @Input() has_mb3 = false;

  /* -------------------------------------------------------------------------- */
  /*                                    form                                    */
  /* -------------------------------------------------------------------------- */

  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() autocomplete = 'off';
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() autoFocus = false;
  @Input() virtualScroll = false;
  @Input() virtualScrollItemSize = 10;
  @Input() appendTo: any = 'body';

  @Input() id: string; // the id of options
  @Input() dataKey: string; // the unique property of each option
  @Input() optionLabel: string; // the label of option that we see
  @Input() optionValue: string; // the value of option that we see
  @Input() imageBaseSrc: string;
  @Input() imageKey: string;
  @Input() imageExtension: string;
  @Input() filter = true;
  @Input() options: any = [];
  @Input() loading = false;
  @Input() emptyMessage = 'Sonuç bulunamadı'; // if options were empty
  @Input() emptyFilterMessage = 'Sonuç bulunamadı'; // if the result of filter was empty
  @Input() scrollHeight = '200px';

  @Output() onChangeEvent = new EventEmitter();

  @Input() ngModelValue: any;
  @Input() translatePrefix: string;

  /* -------------------------------------------------------------------------- */
  /*                                 constructor                                */
  /* -------------------------------------------------------------------------- */
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['disabled'] && this.control) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
  }

  ngOnInit(): void {
    this.renderer.addClass(this.elementRef.nativeElement, 'col-' + this.col);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-sm-' + this.sm);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-md-' + this.md);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-lg-' + this.lg);
    this.renderer.addClass(this.elementRef.nativeElement, 'col-xl-' + this.xl);
  }

  ngAfterContentChecked(): void {
    // this.cdref.detectChanges();
  }

  get control(): AbstractControl {
    if (this.formGroup && this.controlName) {
      return this.formGroup?.controls[this.controlName];
    }
    return null;
  }

  get required(): boolean {
    if (!this.control || !this.control?.validator) {
      return false;
    }

    const validator = this.control.validator({} as AbstractControl);
    return validator?.['required'];
  }

  get screenHight() {
    return document.body.clientHeight;
  }
}
